import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../config/firebase";


const getRegistrationPromoById = async (id) => {
    const docRef = doc(firestore, "registrationPromos", id);
    const docSnap = await getDoc(docRef);

    if(docSnap.exists()){
        return docSnap.data();
    }else{
        console.log("No such document.")
    }
}

export default getRegistrationPromoById;